import React from "react";
export const Clock = ({ colorMain, colorDetail, size, info }) => (
	<svg viewBox="0 0 24 24" width={size} fill="none" className={info}>
		<rect width="13.262" height="13.262" x="5.369" y="6.554" stroke={colorMain} strokeWidth="1.5" rx="6.631" />
		<path stroke={colorDetail} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12.018 13.185V8.908" className="rotate-animate" />
		<path stroke={colorMain} strokeLinecap="round" strokeWidth="1.5" d="M10.5 4.185h3" />
	</svg>
)